// internationalization
import type { TFunction } from 'i18next';

// libraries
import { z } from 'zod';

const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export type DayKey = (typeof DAYS_OF_WEEK)[number];
export { DAYS_OF_WEEK };

const occupancyDaySchema = z.object({
  active: z.boolean(),
  start: z.number().min(0).max(96),
  end: z.number().min(0).max(96),
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function createEditMeterOccupancyFormSchema(_t: TFunction) {
  return z.object({
    Monday: occupancyDaySchema,
    Tuesday: occupancyDaySchema,
    Wednesday: occupancyDaySchema,
    Thursday: occupancyDaySchema,
    Friday: occupancyDaySchema,
    Saturday: occupancyDaySchema,
    Sunday: occupancyDaySchema,
  });
}

export type EditMeterOccupancyFormValues = z.infer<
  ReturnType<typeof createEditMeterOccupancyFormSchema>
>;
